export const genderOptions = (names: string[]) => [
	{ value: 'mal', name: names[0] },
	{ value: 'fem', name: names[1] },
];

export const defaultBirthDate = `${
	new Date().getFullYear() - 21
}-12-31T00:00:00Z`;
